import dayjs from 'dayjs';
import { UiTitle, UiText } from 'znanie-uikit';

import LayoutConfines from 'components/layout/LayoutConfines';

import ImageProxy from 'components/common/ImageProxy';
import LinkTo from 'components/common/LinkTo';

import { Link } from 'components/common/Link';

import { PostType } from 'graphql/types';

import { trackAnalyticsData, AnalyticsEvent } from 'utils/analytics';

import css from './PostsOnMain.module.scss';

interface IProps {
  posts: PostType[];
}

export default function PostsOnMain({ posts }: IProps) {
  const handlePostClick = (post: PostType) => {
    const { slug, publishedAt } = post;

    trackAnalyticsData(AnalyticsEvent.MAIN_NEWS_ITEM_CLICK, {
      slug,
      publishedAt,
    });
  };

  const handleAllPostsClick = () => {
    trackAnalyticsData(AnalyticsEvent.MAIN_NEWS_SHOW_ALL_CLICK);
  };

  return (
    <div className={css.block}>
      <LayoutConfines>
        <div className={css.header}>
          <UiTitle size="big" as="h2">
            Новости
          </UiTitle>
          <LinkTo href="/news" onClick={handleAllPostsClick} />
        </div>
        <div className={css.list}>
          {posts.map((p, i) => (
            <Link
              href={`/news/${p.slug}`}
              key={`post-main-item-${i}`}
              onClick={() => {
                handlePostClick(p);
              }}
            >
              <div className={css.postItem}>
                <div className={css.postPicture}>
                  <ImageProxy
                    src={
                      (p.mobileImageUrl ? p.mobileImageUrl : p.imageUrl) || ''
                    }
                    alt={`Изображение новости: ${p.title}`}
                    objectFit="cover"
                    objectPosition="center"
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM8Uw8AAh0BTZud3BwAAAAASUVORK5CYII="
                    layout="fill"
                    sourceWidth={174}
                    sourceHeight={174}
                    resizingType="fill"
                    gravityType="ce"
                  />
                </div>
                <div className={css.postInfo}>
                  <UiText size="small_x" color="grey" weight="normal">
                    {dayjs(p.publishedAt).format('DD MMMM YYYY')}
                  </UiText>
                  <UiText
                    className={css.postTitle}
                    size="small_plus"
                    weight="normal"
                  >
                    <UiText.Wrapper size={90} disableMore>
                      {p.title || ''}
                    </UiText.Wrapper>
                  </UiText>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </LayoutConfines>
    </div>
  );
}
